var map = {
	"./Aidy.gif": "b2cd1fcca1711b28e813",
	"./discover1.png": "a90ef322b88bb2f3bee8",
	"./zykrr-logo-updated.png": "ad96f63e01f7bf12265d",
	"./zykrr-logo.png": "5aefed9d0b98a8c21f91"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cc55afe5a1e1e3aec636";